module.exports = __webpack_public_path__ + "6bab8b1e44026e1894368b3b4ff6ed1d.svg";